import { render, staticRenderFns } from "./Relate.vue?vue&type=template&id=357cc723"
import script from "./Relate.vue?vue&type=script&lang=js"
export * from "./Relate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports